import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "proto/common/account_id.proto" (package "proto.common", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime"; // @generated message type with reflection information, may provide speed optimized methods

var AccountId$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(AccountId$Type, _MessageType);

  var _super = _createSuper(AccountId$Type);

  function AccountId$Type() {
    _classCallCheck(this, AccountId$Type);

    return _super.call(this, "proto.common.AccountId", [{
      no: 1,
      name: "trade_code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "trade_system_name",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(AccountId$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        tradeCode: "",
        tradeSystemName: "",
        id: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* string trade_code */
          1:
            message.tradeCode = reader.string();
            break;

          case
          /* string trade_system_name */
          2:
            message.tradeSystemName = reader.string();
            break;

          case
          /* string id */
          3:
            message.id = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string trade_code = 1; */
      if (message.tradeCode !== "") writer.tag(1, WireType.LengthDelimited).string(message.tradeCode);
      /* string trade_system_name = 2; */

      if (message.tradeSystemName !== "") writer.tag(2, WireType.LengthDelimited).string(message.tradeSystemName);
      /* string id = 3; */

      if (message.id !== "") writer.tag(3, WireType.LengthDelimited).string(message.id);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AccountId$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message proto.common.AccountId
 */


export var AccountId = new AccountId$Type();